import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.small};
`

export const Title = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ViewModeContainer = styled.div<{
  $minHeight?: number
  $useCard?: boolean
}>`
  padding: ${({ theme, $useCard }) => ($useCard ? '0' : theme.spacing.large)};
  border: ${({ $useCard }) => ($useCard ? 'none' : '1px solid')};
  border-color: ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme, $useCard }) =>
    $useCard ? '0' : theme.borderRadius.medium};
  min-height: ${({ $minHeight }) => ($minHeight ? `${$minHeight}px` : '200px')};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  line-height: 1.6;

  /* Style HTML content */
  p {
    margin: 0 0 ${({ theme }) => theme.spacing.default} 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0 0 ${({ theme }) => theme.spacing.default} 0;
    padding-left: ${({ theme }) => theme.spacing.large};
  }

  li {
    margin-bottom: ${({ theme }) => theme.spacing.xsmall};
  }

  strong {
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  }

  em {
    font-style: italic;
  }

  h1,
  h2,
  h3,
  h4 {
    margin: ${({ theme }) => theme.spacing.medium} 0
      ${({ theme }) => theme.spacing.small} 0;
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  }

  h1 {
    font-size: ${({ theme }) => theme.typography.fontSize.title};
  }
  h2 {
    font-size: ${({ theme }) => theme.typography.fontSize.section};
  }
  h3,
  h4 {
    font-size: ${({ theme }) => theme.typography.fontSize.body};
  }
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-style: italic;
`

export const EditorContainer = styled.div`
  position: relative;
`

export const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.medium};
  margin-top: ${({ theme }) => theme.spacing.medium};
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
`

export const CharacterCount = styled.div<{ $isOver?: boolean }>`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme, $isOver }) =>
    $isOver ? theme.colors.danger : theme.colors.text.secondary};
  font-weight: ${({ theme, $isOver }) =>
    $isOver
      ? theme.typography.fontWeight.medium
      : theme.typography.fontWeight.normal};
`

export const ErrorMessage = styled.div`
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.default};
  background: ${({ theme }) => theme.colors.danger}10;
  border: 1px solid ${({ theme }) => theme.colors.danger};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  color: ${({ theme }) => theme.colors.danger};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  margin-top: ${({ theme }) => theme.spacing.small};
`

export const Recommendation = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: ${({ theme }) => theme.spacing.xsmall};
`
